import { init as MixpanelInit, Mixpanel, PropertyDict } from 'mixpanel';
import { promisify } from 'util';
import config from './config';

export interface MixpanelClient {
  track(name: string, parameters?: PropertyDict): Promise<void>;
}

let mixpanel: Mixpanel;

const track = async (name: string, parameters?: PropertyDict): Promise<void> => {
  const mixpanelInstance: Mixpanel = await getMixpanel();
  const mixpanelTrackAsync: Function = promisify(mixpanelInstance.track);
  await mixpanelTrackAsync(name, parameters);
};

const getMixpanel = async (): Promise<Mixpanel> => {
  if (!mixpanel) {
    const clearToken = config.MIXPANEL_TOKEN_SONASH;
    mixpanel = MixpanelInit(clearToken);
  }

  return mixpanel;
};

const mixpanelClient: MixpanelClient = {
  track,
};

export default mixpanelClient;



// WEBPACK FOOTER //
// ./packages/smart-home-support/api/mixpanelClient.ts